export const BASE_OPPORTUNITY_LIST_URL = "/sales-api/opportunity-list";
